export const API_QC_PROCESS_MONITOR = "admin/api/qc-process/monitor";
